'use strict';
module.exports = require('./globals.json');



//////////////////
// WEBPACK FOOTER
// ./~/globals/index.js
// module id = 2717
// module chunks = 168707334958949